// Dynamic Shopify Price Calculator with Debug
function calculateTotalPrice() {
    let totalPrice = 0;
    console.log('=== Starting Price Calculation ===');
    
    // Get base price from selected truck variant
    const selectedTruck = document.querySelector('input[name="Truck-1\\A"]:checked') || 
                         document.querySelector('input[name*="Truck"]:checked');
    
    if (selectedTruck) {
        const truckValue = selectedTruck.value;
        const truckLabel = selectedTruck.nextElementSibling?.textContent || '';
        console.log('Selected truck value:', truckValue);
        console.log('Selected truck label:', truckLabel);
        
        let basePriceMatch = truckValue.match(/\(\$([0-9,]+)\)/) || 
                           truckLabel.match(/\(\$([0-9,]+)\)/) ||
                           truckValue.match(/\$([0-9,]+)/) ||
                           truckLabel.match(/\$([0-9,]+)/);
        
        if (basePriceMatch) {
            const basePrice = parseFloat(basePriceMatch[1].replace(',', ''));
            totalPrice = basePrice * 100;
            console.log('Found base price:', basePrice, 'Total so far:', totalPrice);
        } else {
            console.log('No base price found in truck selection');
        }
    } else {
        console.log('No truck selected');
    }
    
    // Add bed size additional costs
    const selectedBedSize = document.querySelector('input[name="Bed Size-2\\A"]:checked') ||
                           document.querySelector('input[name*="Bed"]:checked');
    
    if (selectedBedSize) {
        const bedValue = selectedBedSize.value;
        const bedLabel = selectedBedSize.nextElementSibling?.textContent || '';
        console.log('Selected bed value:', bedValue);
        console.log('Selected bed label:', bedLabel);
        
        const bedPriceMatch = bedValue.match(/\+\$([0-9,]+)/) || 
                             bedLabel.match(/\+\$([0-9,]+)/);
        if (bedPriceMatch) {
            const bedPrice = parseFloat(bedPriceMatch[1].replace(',', '')) * 100;
            totalPrice += bedPrice;
            console.log('Found bed addition:', bedPrice / 100, 'Total so far:', totalPrice);
        }
    }
    
    // Add awning additional costs
    const selectedAwning = document.querySelector('input[name="270 Degree Batwing Awnings-3\\A"]:checked') ||
                          document.querySelector('input[name*="Awning"]:checked');
    
    if (selectedAwning) {
        const awningValue = selectedAwning.value;
        const awningLabel = selectedAwning.nextElementSibling?.textContent || '';
        console.log('Selected awning value:', awningValue);
        console.log('Selected awning label:', awningLabel);
        
        const awningPriceMatch = awningValue.match(/\+\$([0-9,]+)/) || 
                               awningLabel.match(/\+\$([0-9,]+)/);
        if (awningPriceMatch) {
            const awningPrice = parseFloat(awningPriceMatch[1].replace(',', '')) * 100;
            totalPrice += awningPrice;
            console.log('Found awning addition:', awningPrice / 100, 'Total so far:', totalPrice);
        }
    }
    
    // Add all checked addon prices
    const addonCheckboxes = document.querySelectorAll('.add-on-cb input[type="checkbox"]:checked');
    console.log('Found', addonCheckboxes.length, 'checked addons');
    
    addonCheckboxes.forEach(checkbox => {
        const priceElement = checkbox.closest('.add-on-cb').querySelector('.price');
        if (priceElement) {
            const priceText = priceElement.textContent;
            const priceMatch = priceText.match(/\+\$([0-9,]+\.?\d*)/);
            if (priceMatch) {
                const addonPrice = parseFloat(priceMatch[1].replace(',', '')) * 100;
                totalPrice += addonPrice;
                console.log('Found addon addition:', addonPrice / 100, 'Total so far:', totalPrice);
            }
        }
    });
    
    const totalDollars = totalPrice / 100;
    console.log('Final total:', totalDollars);
    updatePriceDisplay(totalDollars);
    
    return totalDollars;
}

function updatePriceDisplay(total) {
    const totalPriceElement = document.getElementById('total-price');
    if (totalPriceElement) {
        totalPriceElement.textContent = '$' + total.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
        console.log('Updated display to:', totalPriceElement.textContent);
    } else {
        console.log('Could not find #total-price element');
    }
}

// Universal click handler for the entire product section
function setupClickHandler() {
    const productSection = document.querySelector('product-info');
    if (productSection) {
        console.log('Setting up click handler on product section');
        
        productSection.addEventListener('click', function(event) {
            console.log('Click detected on:', event.target.type, event.target.tagName);
            setTimeout(calculateTotalPrice, 20);
        });
        
        productSection.addEventListener('change', function(event) {
            console.log('Change detected on:', event.target.type, event.target.name);
            setTimeout(calculateTotalPrice, 20);
        });
    } else {
        console.log('Could not find product section');
    }
}

// Manual recalculation function
function recalculatePrice() {
    console.log('Manual recalculation triggered');
    return calculateTotalPrice();
}

// =============================================
// Field Error Helpers
// =============================================

function showFieldError(input, message) {
    clearFieldError(input);

    input.style.border = '1px solid #e74c3c';

    const error = document.createElement('span');
    error.className = 'field-error-msg';
    error.style.cssText = `
        display: block;
        color: #e74c3c;
        font-size: 11px;
        margin-top: 3px;
    `;
    error.textContent = message;

    input.insertAdjacentElement('afterend', error);

    input.addEventListener('input', () => clearFieldError(input), { once: true });
}

function clearFieldError(input) {
    input.style.border = '';
    const existing = input.parentNode.querySelector('.field-error-msg');
    if (existing) existing.remove();
}

// =============================================
// Shopify Multi-Product Cart Handler
// =============================================

function addAllToCart() {
    // Validate vehicle fields if they exist on the page (camper template)
    const makeInput = document.getElementById('make');
    const modelInput = document.getElementById('model');
    const yearInput = document.getElementById('year');

    const vehicleFieldsExist = makeInput && modelInput && yearInput;

    if (vehicleFieldsExist) {
        const allFilled = makeInput.value.trim() && modelInput.value.trim() && yearInput.value.trim();

        if (!allFilled) {
            if (!makeInput.value.trim()) showFieldError(makeInput, 'Vehicle make is required');
            if (!modelInput.value.trim()) showFieldError(modelInput, 'Vehicle model is required');
            if (!yearInput.value.trim()) showFieldError(yearInput, 'Vehicle year is required');
            return;
        }
    }

    // Get main product variant ID
    const mainVariantInput = document.querySelector('.product-variant-id');
    const mainVariantId = mainVariantInput ? mainVariantInput.value : null;

    if (!mainVariantId) {
        console.error('Main variant ID not found');
        return;
    }

    const cartItems = [];
    const properties = collectFormProperties();

    // Add main product with properties
    cartItems.push({
        id: mainVariantId,
        quantity: 1,
        properties: properties
    });

    console.log('Main variant ID:', mainVariantId);
    console.log('Properties:', properties);

    // Add all selected addon variants
    const checkedAddons = document.querySelectorAll('.add-on-cb input[type="checkbox"]:checked');
    console.log('Found', checkedAddons.length, 'checked addons');

    checkedAddons.forEach(checkbox => {
        const addonVariantId = checkbox.value || checkbox.id;
        if (addonVariantId && addonVariantId !== checkbox.name) {
            cartItems.push({
                id: addonVariantId,
                quantity: 1
            });
            console.log('Adding addon variant:', addonVariantId);
        }
    });

    if (cartItems.length > 0) {
        addItemsToCart(cartItems);
    }
}

function collectFormProperties() {
    const properties = {};

    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) return properties;

    // Collect all properties from inputs with name="properties[...]"
    const propertyInputs = productForm.querySelectorAll(
        'input[name*="properties["], select[name*="properties["], textarea[name*="properties["]'
    );

    propertyInputs.forEach(input => {
        const match = input.name.match(/properties\[(.+?)\]/);
        if (match && input.value.trim() !== '') {
            properties[match[1]] = input.value.trim();
        }
    });

    return properties;
}

function addItemsToCart(items) {
    const submitButton = document.querySelector('form[action="/cart/add"] button[type="submit"]');
    const originalText = submitButton ? submitButton.innerHTML : '';

    if (submitButton) {
        submitButton.disabled = true;
        submitButton.innerHTML = '<span>Adding to cart...</span>';
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        console.log('Successfully added to cart:', data);
        showSuccessMessage();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
        showErrorMessage('Failed to add items to cart. Please try again.');
    })
    .finally(() => {
        if (submitButton) {
            submitButton.disabled = false;
            submitButton.innerHTML = originalText;
        }
    });
}

function showSuccessMessage() {
    window.location.href = '/cart';
}

function showErrorMessage(msg) {
    const message = document.createElement('div');
    message.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #e74c3c;
        color: white;
        padding: 15px 20px;
        border-radius: 5px;
        z-index: 9999;
        font-weight: bold;
    `;
    message.textContent = msg;
    document.body.appendChild(message);

    setTimeout(() => {
        message.remove();
    }, 5000);
}

function setupCartHandler() {
    const productForm = document.querySelector('form[action="/cart/add"]');

    if (productForm) {
        productForm.addEventListener('submit', function(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            addAllToCart();
        }, true); // capture phase - runs before Shopify's handler

        console.log('Cart handler setup complete');
    } else {
        console.log('Could not find form');
    }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM loaded, initializing');
    setupClickHandler();
    setupCartHandler();
    calculateTotalPrice();
});

// Manual trigger function
function triggerAddToCart() {
    addAllToCart();
}